// global-article.js                                            ~/js/swipers
///////////////////////////////////////////////////////////////////////////

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// Global - Article Swiper
export const GlobalArticleSwiper = new Swiper('.article-swiper', {
  modules: [Navigation, Pagination],
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  autoplay: false,
  watchOverflow: true,
  breakpoints: {
    // when window width is <= 320px
    320: {
      centeredSlides: true,
    },
    // when window width is <= 480px
    480: {
      centeredSlides: true,
    },
    // when window width is <= 1024px
    1024: {
      centeredSlides: false,
    },
  },
});
